;(function () {
	'use strict';

	if (!customElements.get('showcase-slider')) {
		class ShowcaseSlider extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector('.case-slider');
				this.swiper = null;
				this.slides = Array.from(this.querySelector('.swiper-slide'));
			}

			connectedCallback() {
				this.initSwiper();
				window.addEventListener('resize', () => this.initSwiper.call(this));
			}

			attributeChangedCallback() {
				this.initSwiper();
			}
		}

		ShowcaseSlider.prototype.initSwiper = function() {
			if (this.slider) {
				const { id } = this.slider.dataset;
				const selector = `.case-slider-${id}`;

				this.swiper = new Swiper(selector, {
					loop: true,
					// speed: 800,
					slidesPerView: 'auto',
					spaceBetween: 20,
					autoplay: false,
					// autoplay: {
					// 	delay: 3000, // Slide every 3 seconds
					// 	disableOnInteraction: false, // Keep autoplay even after user interaction
					// },
					navigation: {
						nextEl: `.media-slider .slider-arrow-next`,
						prevEl: `.media-slider .slider-arrow-prev`,
					  },
					breakpoints: {
						1200: {
							spaceBetween: 30,
						},
					},
				});




				// Pause autoplay on hover
				// const sliderEl = document.querySelector(selector);
				// if (sliderEl) {
				// 	sliderEl.addEventListener('mouseenter', () => {
				// 		this.swiper.autoplay.stop();
				// 	});
				// 	sliderEl.addEventListener('mouseleave', () => {
				// 		this.swiper.autoplay.start();
				// 	});
				// }


			}
		};

		customElements.define('showcase-slider', ShowcaseSlider);
	}
})();
